// ____ 로컬 헬퍼  ____

export function hasValue(v) {
  return v !== undefined && v !== null && v !== "" && v !== "undefined";
}
